
import { Card, CardContent } from "@/components/ui/card";

interface BandStats {
  A: { count: number; percentage: number };
  B: { count: number; percentage: number };
  C: { count: number; percentage: number };
  D: { count: number; percentage: number };
}

interface BandingSummaryCardProps {
  bandStats: BandStats;
}

const BandingSummaryCard = ({ bandStats }: BandingSummaryCardProps) => {
  // Ensure bandStats is properly defined with default values
  const safeBandStats = {
    A: { count: 0, percentage: 0, ...bandStats?.A },
    B: { count: 0, percentage: 0, ...bandStats?.B },
    C: { count: 0, percentage: 0, ...bandStats?.C },
    D: { count: 0, percentage: 0, ...bandStats?.D }
  };

  return (
    <Card className="bg-secondary/50 border-primary/20 h-full w-[450px]">
      <CardContent className="p-2 h-full w-[450px] border rounded-xl border-primary">
        <h3 className="text-white text-[20px] font-semibold mb-2 px-4">Banding Summary</h3>
        
        <div className="grid grid-cols-2 gap-1 h-[175px] px-6 flex flex-1 items-center justify-center">
          <Card className="bg-blue-600/20 h-[70px] w-[180px] border-blue-400/30">
            <CardContent className="p-0.5 h-full flex items-center justify-center">
              <div className="text-center">
                <div className="text-blue-400 font-bold text-xs">Band A</div>
                <div className="text-white text-[10px] leading-tight mt-0.5">
                  {safeBandStats.A.count} Member{safeBandStats.A.count !== 1 ? 's' : ''} ({safeBandStats.A.percentage}%)
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-green-600/20 h-[70px] w-[180px] border-green-400/30">
            <CardContent className="p-0.5 h-full flex items-center justify-center">
              <div className="text-center">
                <div className="text-green-400 font-bold text-xs">Band B</div>
                <div className="text-white text-[10px] leading-tight mt-0.5">
                  {safeBandStats.B.count} Member{safeBandStats.B.count !== 1 ? 's' : ''} ({safeBandStats.B.percentage}%)
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-amber-600/20 h-[70px] w-[180px] border-amber-400/30">
            <CardContent className="p-0.5 h-full flex items-center justify-center">
              <div className="text-center">
                <div className="text-amber-400 font-bold text-xs">Band C</div>
                <div className="text-white text-[10px] leading-tight mt-0.5">
                  {safeBandStats.C.count} Member{safeBandStats.C.count !== 1 ? 's' : ''} ({safeBandStats.C.percentage}%)
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card className="bg-red-600/20 h-[70px] w-[180px] border-red-400/30">
            <CardContent className="p-0.5 h-full flex items-center justify-center">
              <div className="text-center">
                <div className="text-red-400 font-bold text-xs">Band D</div>
                <div className="text-white text-[10px] leading-tight mt-0.5">
                  {safeBandStats.D.count} Member{safeBandStats.D.count !== 1 ? 's' : ''} ({safeBandStats.D.percentage}%)
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </CardContent>
    </Card>
  );
};

export default BandingSummaryCard;
